// Dependency
import React from 'react';

// Styles
import * as styles from './quantity.module.scss';

// Assets
import iconPlus from '../mini-cart/assets/icon-plus.svg';
import iconMinus from '../mini-cart/assets/icon-minus.svg';
import { useCart } from '../../contexts/cart-context';

// Template
const Quantity = (props) => {

  const { changeQty } = useCart();

  return (
    <div className={`${styles.quantity}`}>
      <button
        className={`${styles.quantity__button}`}
        onClick={ () => { changeQty( props.line, 'put', props.quantity - 1, props.item, 'remove' ) } }>
        <img src={iconMinus} alt={""} />
      </button>
      <input key={props.line} type="number" className={`${styles.quantity__input}`} readOnly value={props.quantity} />
      <button
        className={`${styles.quantity__button}`}
        onClick={ () => { changeQty( props.line, 'put', props.quantity + 1, props.item, 'add' ) } }>
        <img src={iconPlus} alt={""} />
      </button>
    </div>
  );
};

export default Quantity;